import { render, staticRenderFns } from "./Stake.vue?vue&type=template&id=6541ea88&scoped=true&"
import script from "./Stake.vue?vue&type=script&lang=ts&"
export * from "./Stake.vue?vue&type=script&lang=ts&"
import style0 from "./Stake.vue?vue&type=style&index=0&id=6541ea88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6541ea88",
  null
  
)

export default component.exports